import React from "react";

function ReturnRefund() {
  return (
    <div>
      <h2 style={{ marginBottom: 20, paddingLeft: 20, paddingRight: 20, paddingTop: 20 }}>Return & Refund Policy</h2>
      <ul style={{ marginLeft: 20, marginRight: 20 }}>
        <li>
          We will issue a product exchange for any type of product that is
          returned in an unused, sellable and intact condition, in its original
          packaging. The product has to be returned within 15 days of the
          delivery date. Missing out on items, wrong order or excess charges
          must be reported within 24 to 48 hours of delivery. We only offer
          exchanges; we do not offer any refunds or any type of credits.
        </li>
        <li>
          Only products bought exclusively from the Parchun King can be returned
          back to us. We will certainly not accept returns of products bought
          from any other third-party websites or physical stores. The returns
          form is available in my account section must be completed in order to
          process your return request.
        </li>
        <li>
          At the same time, you can email us at support@parchunking.com. Please
          allow one to 2 weeks for your return to be processed, it will need to
          be vetted by our customer service team. You will receive a tele call
          or an email once your return is processed.
        </li>
        <li>
        Clearly outline the conditions under which customers are eligible for a refund. This may include defective or damaged items, incorrect orders, or other specific circumstances.
        </li>
        <li>
        Explain the steps customers need to take to initiate a refund. This may involve contacting customer support, completing a refund request form, or using an online portal on your website.
        </li>
        <li>
        State whether customers need to provide proof of purchase, such as an order confirmation email or receipt, when requesting a refund.
        </li>
        <li>
        Clearly communicate the expected condition of the returned items. For example, products should be in their original packaging and unused for a full refund.
        </li>
        <h3 style={{ marginTop: 20, marginBottom: 10 }}>Terms & Conditions:</h3>
        <li>
          All returned products have to be accompanied with a copy of the
          original invoice.
        </li>
        <li>Each item can only be exchanged once.</li>
        <li>Shipping costs will not be refunded.</li>
        <li>
          All gifts or promotional products received with your purchase must be
          returned with your order.
        </li>
        <li>
          All items bought on sale are final - we cannot offer any returns or
          exchanges on sale products.
        </li>
        <li>
          If the return complies with our return and exchange policy, you will
          be eligible to exchange the product for a product of the same or
          lesser value. We will not refund the difference. In the case that the
          items exceed the original value, you will be required to pay the
          difference.
        </li>
        <li>
          Please note: Although we have tried to precisely show the actual
          colour of the products, there may be a minor variation based on the
          operating system you are using.
        </li>
      </ul>
      <div style={{ textAlign: 'center', paddingTop: 7, paddingBottom: 7, backgroundColor: "lightgray" }}>
        Made with ❤️ by Sheetal Trading Company
      </div>
    </div>
  );
}

export default ReturnRefund;
